import { render } from "./InternalIconField.vue?vue&type=template&id=71120452"
import script from "./InternalIconField.vue?vue&type=script&lang=js"
export * from "./InternalIconField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__